/**
 * created by xcc on 2021/10/22
 * 新媒体批量组件
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    Modal,
    Table,
    Input,
    Button,
    Divider,
    Checkbox,
    Progress, Radio, Pagination
} from "antd";
import {message} from "../../../sysManagement/utils/sysManagementUtils";
import Scrollbars from "react-custom-scrollbars";
import BatchAdd from "./BatchAdd";
import {
    batchAddTemp,
    cancelExport, getActHistory, getFlowEndData, getTempBatchAddData,
    getTransferUsers,
    transferNewMedias, updateNewMedia
} from "../../actions/newMediaManage";
import NewAddMedia from "./NewAddMedia";
import {getInfoFromLocalStorage} from "../../../../actions";
import {transferSpecialCharacter} from "../../../../utils";

const {Search} = Input;

export default class BatchComponents extends Component {
    static defaultProps = {}
    static propTypes = {
        title: PropTypes.string.isRequired
    }

    constructor(props) {
        super(props);
        this.state = {
            title: "",
            transferPersonInfo: [], //被转交人数据
            transferPersonVisible: false,
            transferPersonBtnShow: true,
            transferPerson: "",
            searchValue: "",
            checkedAll: false,
            currentMedia: {},
            batchButtons: [],
            selectedTransferPerson: null,
            simpleAddOrEdit: false,
            progressVisible: false,
            batchSimpleEdit: false,
            step: 0,
            percent: 0,
            dealCount: 0,
            page: 1,
            size: 10,
            total: 0,
            hideOnSinglePage: true,
            indeterminate: false
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillReceiveProps(nextProps, nextContext) {

    }

    render() {
        const auditColumns = [
            {
                title: (() => {
                    let checkedAll = this.props.batchData.length ? this.props.batchData.every(item => item.checked) : false;
                    let checkedLength = this.props.batchData.length ? this.props.batchData.filter(item => item.checked).length : 0
                    let indeterminate = this.props.batchData.length && checkedLength > 0 && checkedLength < this.props.batchData.length;
                    return (
                        <Checkbox checked={checkedAll} indeterminate={indeterminate} onChange={(e) => {
                            this.props.onAllChange(e.target.checked);
                        }}/>
                    )
                })(),
                align: 'center',
                width: 50,
                key: "checked",
                render: (record) => {
                    return (
                        <div>
                            <Checkbox checked={record.checked} onChange={() => {
                                record.checked = !record.checked;
                                this.setState({})
                            }}/>
                        </div>
                    )
                }
            },
            {
                title: '媒体名称',
                align: 'left',
                dataIndex: 'name',
                ellipsis: true,
                key: "name",
            },
            {
                title: '媒体状态',
                key: 'statusName',
                dataIndex: 'statusName',
                ellipsis: true,
                align: 'left',
            },
            {
                title: '媒体平台',
                key: 'newMediaTypeName',
                dataIndex: 'newMediaTypeName',
                ellipsis: true,
                align: 'left',
            },
            {
                title: '媒体LOGO',
                key: 'logo',
                ellipsis: true,
                align: 'left',
                render: (record => {
                    return (
                        <div>{record.logo ? <img src={record.logo} alt="avatar" style={{
                            width: '32px',
                            height: '32px',
                            objectFit: 'cover'
                        }}/> : null}</div>
                    )
                })
            },
            {
                title: '媒体账号',
                dataIndex: 'account',
                key: 'account',
                ellipsis: true,
                align: 'left',
            },
            {
                title: '主责单位',
                dataIndex: 'mainDeptName',
                ellipsis: true,
                key: 'mainDeptName',
                align: 'left',
            },
            {
                title: '负责人',
                dataIndex: 'leader',
                ellipsis: true,
                key: 'leader',
                align: 'left',
            },
            {
                title: '联系电话',
                dataIndex: 'contact',
                ellipsis: true,
                key: 'contact',
                align: 'left',
            },
            {
                title: '操作',
                ellipsis: true,
                key: 'operate',
                align: 'left',
                render: (record => {
                    return (
                        <div style={{display: "flex", alignItems: "center"}}>{
                            this.props.batchTitle === "批量转交" ?
                                <div style={{fontWeight: 400, fontSize: 14, color: "#1890ff", cursor: "pointer"}}
                                     onClick={() => {
                                         this.viewDetail(record)
                                     }}>查看</div>
                                : (window.top.currentUser.id === record.createById) ?
                                    <div style={{display: "flex"}}>
                                        <div style={{marginRight: "10px",}}>
                                            <div
                                                style={{fontWeight: 400, fontSize: 14, color: "#1890ff", cursor: "pointer"}}
                                                onClick={() => {
                                                    this.editDetail(record, "edit")
                                                }}>编辑
                                            </div>
                                        </div>
                                        <div>
                                            <div
                                                style={{fontWeight: 400, fontSize: 14, color: "#1890ff", cursor: "pointer"}}
                                                onClick={() => {
                                                    this.editDetail(record)
                                                }}>查看
                                            </div>
                                        </div>
                                    </div>
                                    : <div style={{fontWeight: 400, fontSize: 14, color: "#1890ff", cursor: "pointer"}}
                                           onClick={() => {
                                               this.editDetail(record)
                                           }}>查看</div>
                        }</div>
                    )
                })
            },
        ];
        let height = window.innerHeight - 100;
        return (
            <div style={{height: height}} id={"batchComponent"}>
                <div style={{
                    backgroundColor: "#fff",
                    padding: "16px 25px 14px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderRadius: "5px 5px 0px 0px"
                }}>
                    <div style={{
                        fontSize: 16,
                        fontWeight: 550,
                        color: "#222",
                        fontFamily: "Microsoft YaHei"
                    }}>{this.props.batchTitle}</div>
                    <div>当前位置：媒体管理 > <span style={{color: "#1890ff"}}>{this.props.batchTitle}</span><span
                        style={{margin: "0px 10px"}}>|</span><span onClick={() => {
                        this.cancelExport();
                    }} style={{
                        color: "#1890ff",
                        cursor: "pointer"
                    }}>返回上一级</span></div>
                </div>
                <Divider/>
                {this.props.batchTitle === "批量转交" ?
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#fff",
                        padding: "10px 25px 0px"
                    }}>
                        {
                            this.state.transferPersonBtnShow ?
                                <div><Button
                                    style={{cursor: "pointer"}} type={"primary"}
                                    onClick={() => {
                                        this.state.page = 1;
                                        this.state.searchValue = "";
                                        this.selectTransferPerson()
                                    }}>选择被转交人</Button>
                                </div>
                                : <div>
                                    <span>{this.state.transferPerson}</span>
                                    <Button
                                        style={{cursor: "pointer"}} type={"primary"}
                                        onClick={() => {
                                            this.state.page = 1;
                                            this.state.searchValue = "";
                                            this.selectTransferPerson()
                                        }}>重新选择</Button>
                                    <span
                                        style={{padding: "0 10px"}}>{this.state.selectedTransferPerson ? this.state.selectedTransferPerson.name : ""}</span>
                                </div>
                        }
                    </div>
                    : null}
                {
                    this.props.batchTitle === "批量新增" ?
                        //批量新增组件
                        <BatchAdd
                            title={"批量新增"}
                            mainDutyDept={this.props.mainDutyDept}
                            mediaPlatform={this.props.mediaPlatform}
                            onRef={(c) => this.batchAdd = c}
                            cancelExport={() => this.cancelExport()}
                            showCurrentPageType={this.props.showCurrentPageType}
                            getNeedAuditMedia={() => this.props.getNeedAuditMedia()}
                            batchTitle={this.props.batchTitle}
                            initProcess={this.initProcess}
                            batchAddData={this.props.batchAddData}
                            goBack={() => this.props.goBack()}
                            getTempBatchAdd={() => this.props.getTempBatchAdd()}
                        /> :
                        //批量转交、批量审核
                        <div style={{backgroundColor: "#fff", padding: "10px 24px"}}>
                            <Scrollbars autoHide autoHeight
                                        autoHeightMax={this.props.batchTitle === "批量转交" ? height - 220 : height - 177}>
                                <Table columns={auditColumns} pagination={false} dataSource={this.props.batchData}
                                />
                            </Scrollbars>
                        </div>
                }
                <style>{`#batchComponent .ant-divider-horizontal{margin:0px;}
                #batchComponent .ant-divider, .ant-divider-vertical{top:0.5px;}
                #batchComponent .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #batchComponent .ant-table-placeholder{border-bottom: 0;}
                    #batchComponent .ant-table-body{border: none;}
                `}</style>
                <Divider style={{display: !this.props.batchData.length ? "none" : "block"}}/>
                {/*渲染底部按钮*/}
                {this.renderBottomBtn()}
                {/*渲染被转交人*/}
                {this.props.batchTitle === "批量转交" ? this.renderTransferPerson() : null}
                {/*批量审核渲染媒体信息组件*/}
                <NewAddMedia
                    title={this.state.title}
                    onRef={(newAddMedia) => this.newAddMedia = newAddMedia}
                    currentMedia={this.state.currentMedia}
                    mainDutyDept={this.props.mainDutyDept}
                    mediaPlatform={this.props.mediaPlatform}
                    currentUser={this.props.currentUser}
                    showCurrentPageType={this.props.showCurrentPageType}
                    getNeedAuditMedia={(callback) => this.props.getNeedAuditMedia(callback)}
                    batchTitle={this.props.batchTitle}
                    batchData={this.props.batchData}
                    goBack={() => this.props.goBack()}
                    simpleAddOrEdit={this.state.simpleAddOrEdit}
                    cancelExport={() => this.cancelExport()}
                    simpleAddOrEditChange={() => this.simpleAddOrEditChange()}
                    initProcessOperate={(batchData) => this.initProcess(batchData)}
                    batchAuditValueChange={(batchAuditValue) => this.props.batchAuditValueChange(batchAuditValue)}
                    checkedChanage={() => {
                        this.state.checkedAll = true
                    }}
                    batchSimpleEdit={this.state.batchSimpleEdit}
                />
                <Modal
                    width={416}
                    height={152}
                    title="正在转交"
                    visible={this.state.progressVisible}
                    footer={null}
                    centered={true}
                    keyboard={false}
                    maskClosable={false}
                >
                    <div>
                        <Progress percent={this.state.percent} step={this.state.step} status="active"/>
                        <div>正在批量转交中，大约剩余{this.state.step}s</div>
                    </div>
                </Modal>
            </div>
        )
    }

    simpleAddOrEditChange() {
        this.setState({
            simpleAddOrEdit: false
        })
    }

    //批量审核初始化流程
    initProcess = (batchData) => {
        if (batchData && batchData.length > 0) {
            this.newAddMedia && this.newAddMedia.init(batchData[0], (batchButtons) => {
                this.setState({
                    batchButtons
                })
            });
        } else {
            this.setState({
                batchButtons: []
            })
        }
    }

    //查看详情
    viewDetail(record) {
        this.newAddMedia && this.newAddMedia.openModal();
        this.state.title = "媒体详情";
        this.setState({
            currentMedia: record,
            simpleAddOrEdit: true
        }, () => this.newAddMedia.init(record));
    }

    //编辑回显数据
    editDetail(record, type) {
        this.newAddMedia && this.newAddMedia.openModal();
        this.state.title = type ? "修改媒体" : "媒体详情";
        this.setState({
            currentMedia: record,
            simpleAddOrEdit: true,
            batchSimpleEdit: type ? true : false
        }, () => {
            this.newAddMedia.init(record)
        });
    }

    //渲染底部按钮
    renderBottomBtn() {
        if (this.props.batchTitle === "批量转交") {
            return (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "0px 0px 5px 5px"
                }}>
                    <div style={{marginRight: 30}}><Button onClick={() => this.props.goBack()}>取消</Button></div>
                    <div><Button type={"primary"} onClick={() => this.transfer()}>确认转交</Button></div>
                </div>
            )
        }
        if (this.props.batchTitle === "批量新增审核" || this.props.batchTitle === "批量更新审核" || this.props.batchTitle === "批量注销审核" || this.props.batchTitle === "批量删除审核") {
            return (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    padding: "20px",
                    borderRadius: "0px 0px 5px 5px"
                }}>
                    {this.props.batchData.length > 0 ? this.state.batchButtons : null}
                </div>
            )
        }
    }

    //取消导入
    cancelExport() {
        if (this.props.batchTitle === "批量新增") {
            getTempBatchAddData({}, (data) => {
                let isEdit = this.batchAdd.state.saveAfterExit;  //是否提示
                if (isEdit && data && data.length > 0) {
                    Modal.warning({
                        title: '确认是否强制退出？',
                        content: <div>
                            <div>检测到当前有操作没有保存，退出后当前修改数据将会丢失</div>
                        </div>,
                        centered: 'centered',
                        okText: "确定",
                        okCancel: "取消",
                        onOk: () => {
                            this.props.goBack();
                            cancelExport({}, (res) => {
                                console.log(res);
                            })
                        }
                    })
                } else {
                    if (data && data.length === 0) {
                        //批量列表没有数据时直接暂存
                        //保存
                        let newMediaIds = [];
                        this.props.batchData.forEach(item => {
                            newMediaIds.push(item.id);
                        })
                        let body = {}
                        if (newMediaIds.length > 0) {
                            body.newMediaIds = newMediaIds
                        }
                        batchAddTemp(body, (data) => {
                        })
                    }
                    this.props.goBack();
                    cancelExport({}, (res) => {
                        console.log(res);
                    })
                }
            })
        } else {
            this.props.goBack();
        }
    }

    //批量转交取消全选
    cancelAllChecked() {
        let {transferPersonInfo} = this.state;
        transferPersonInfo.length && transferPersonInfo.forEach(item => {
            item.checked = false;
        });
    }

    //转交人
    renderTransferPerson() {
        const transferPersonColumn = [
            {
                title: "",
                key: 'checked',
                width: 50,
                render: (record => {
                    return (
                        <div>
                            <Radio checked={record.checked} onChange={() => {
                                this.cancelAllChecked()
                                record.checked = !record.checked;
                                this.setState({})
                            }}/>
                        </div>
                    )
                })
            },
            {
                title: '姓名',
                key: 'name',
                ellipsis: true,
                width: 200,
                render: (record) => {
                    return (
                        <div style={{
                            width: 200,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{record.name}</div>
                    )
                }
            },
            {
                title: '账号',
                key: 'account',
                ellipsis: true,
                width: 200,
                render: (record) => {
                    return (
                        <div style={{
                            width: 200,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{record.account}</div>
                    )
                }
            },
            {
                title: '角色',
                key: 'role',
                ellipsis: true,
                render: (record) => {
                    let roles = [];
                    record.roleList && record.roleList.forEach(item => {
                        roles.push(item.roleName);
                    })
                    return (
                        <div style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}>{roles.join(",")}</div>
                    )
                }
            }
        ]
        return (
            <Modal
                title={"选择被转交人"}
                maskClosable={false}
                visible={this.state.transferPersonVisible}
                onCancel={() => {
                    this.setState({
                        transferPersonVisible: false,
                        searchValue: ""
                    })
                }}
                onOk={() => {
                    let selectedTransferPerson = null;
                    let {transferPersonInfo} = this.state;
                    transferPersonInfo.length && transferPersonInfo.forEach(item => {
                        if (item.checked) {
                            selectedTransferPerson = item
                        }
                    });
                    this.setState({
                        transferPersonVisible: false,
                        transferPersonBtnShow: false,
                        selectedTransferPerson
                    })
                }}
                className={"transferModal"}
                width={920}
                centered={true}
            >
                <div id={"transferTable"}>
                    <div style={{marginBottom: 10}}>
                        <Search
                            allowClear={true}
                            placeholder="搜索姓名/账号"
                            onSearch={(searchValue) => {
                                this.state.page = 1;
                                this.setState({
                                    searchValue
                                }, () => {
                                    this.selectTransferPerson()
                                })
                            }}
                            value={this.state.searchValue}
                            onChange={(e) => {
                                this.setState({
                                    searchValue: e.target.value,
                                });
                            }}
                            style={{width: 200}}
                        />
                    </div>
                    <Scrollbars autoHide autoHeight autoHeightMax={340}>
                        <Table columns={transferPersonColumn} pagination={false}
                               dataSource={this.state.transferPersonInfo}
                        />
                        <style>{`
                    #transferTable .ant-table-row:nth-child(2n) {
                        background-color: rgba(245, 248, 252, 1);
                    }
                    #transferTable .ant-table-body{border:none !important}
                    #transferTable .ant-table-placeholder{border-bottom: 0;}
                    .transferModal .ant-modal-body{padding: 10px 24px;}
                `}</style>
                    </Scrollbars>
                    {this.state.transferPersonInfo && this.state.transferPersonInfo.length > 0 ? <div style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        paddingTop: "10px",
                        marginTop: 10,
                        borderTop: "1px solid #ebebeb"
                    }}>
                        <Pagination
                            showQuickJumper
                            current={this.state.page}
                            pageSize={this.state.size}
                            total={this.state.total}
                            showTotal={total => `共 ${total} 条`}
                            showSizeChanger
                            onChange={(page, pageSize) => this.transferChange(page, pageSize)}
                            onShowSizeChange={(page, pageSize) => {
                                this.state.hideOnSinglePage = false;
                                this.transferChange(page, pageSize)
                            }}
                        />
                    </div> : ""}
                </div>
            </Modal>
        )
    }

    transferChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.selectTransferPerson();
    }

    //选择被转交人
    selectTransferPerson() {
        let {selectedTransferPerson} = this.state;
        let {deptIds, account, id} = getInfoFromLocalStorage("currentUser");
        let body = {
            start: this.state.page,
            size: this.state.size,
            "queryStr": {
                "queryRelationTypeEnum": "AND",
                "queryList": [
                    {
                        "queryTypeEnum": "NE",
                        "fieldName": "_id",
                        "queryRelationTypeEnum": "AND",
                        "value": id,
                        "valueTypeEnum": "STRING",
                        "queryList": null
                    },
                    {
                        "queryTypeEnum": "IS",
                        "fieldName": "status",
                        "queryRelationTypeEnum": "AND",
                        "value": "1",
                        "valueTypeEnum": "INT",
                        "queryList": null
                    },
                    {
                        "queryTypeEnum": "IN",
                        "fieldName": "deptIds",
                        "queryRelationTypeEnum": "AND",
                        "value": deptIds,
                        "valueTypeEnum": "STRING",
                        "queryList": null
                    }
                ]
            },
        };
        if (this.state.searchValue) {
            body.queryStr.queryList.push({
                "queryRelationTypeEnum": "OR",
                "queryList": [
                    {
                        "queryTypeEnum": "LIKE",
                        "fieldName": "name",
                        "queryRelationTypeEnum": "AND",
                        "value": transferSpecialCharacter(this.state.searchValue),
                        "valueTypeEnum": "STRING",
                        "queryList": null
                    },
                    {
                        "queryTypeEnum": "LIKE",
                        "fieldName": "account",
                        "queryRelationTypeEnum": "AND",
                        "value": transferSpecialCharacter(this.state.searchValue),
                        "valueTypeEnum": "STRING",
                        "queryList": null
                    }
                ]
            });
        }
        getTransferUsers(body, (res) => {
            let total = 0;
            let hideOnSinglePage = true;
            let transferPersonInfo = [];
            if (res && res.data && res.data.length) {
                total = res.count;
                hideOnSinglePage = false;
                transferPersonInfo = res.data;
                res.data.forEach(item => {
                    if (selectedTransferPerson && (item.name === selectedTransferPerson.name)) {
                        item.checked = true;
                    }
                })
            }
            this.setState({
                transferPersonVisible: true,
                transferPersonInfo,
                total,
                hideOnSinglePage
            });
        })

    }

    //确认转交
    transfer() {
        let {selectedTransferPerson} = this.state;
        let {batchData} = this.props;
        let arr = [];
        batchData && batchData.length > 0 && batchData.forEach(item => {
            if (item.checked) {
                arr.push(item);
            }
        })
        if (!selectedTransferPerson) return message.warn("请选择被转交人");
        if (!arr.length) return message.warn("请选择需要转交的媒体");

        Modal.warning({
            title: '请注意，转交操作不可逆',
            content: <div>
                <div style={{color: "red"}}>审核中的媒体在转交后会结束审核流程，</div>
                <div>你还要继续吗？</div>
            </div>,
            centered: 'centered',
            okText: "确定",
            okCancel: "取消",
            onOk: () => {
                this.setState({
                    progressVisible: true,
                    percent: 0,   //重置步数
                    step: arr.length,
                    dealCount: 0
                }, () => {
                    batchData && batchData.length > 0 && batchData.forEach(item => {
                        if (item.checked) {
                            if (item.processType === 1) {
                                if (item.statusName !== "更新审核不通过") {
                                    //更新流程转交还原数据
                                    this.revertData(item.uuid, () => {
                                        this.transferOk(item.code, selectedTransferPerson, item.id, item.statusName, arr)
                                    });
                                } else {
                                    this.revertToOldData(item, () => {
                                        this.transferOk(item.code, selectedTransferPerson, item.id, item.statusName, arr)
                                    });
                                }
                            } else {
                                this.transferOk(item.code, selectedTransferPerson, item.id, item.statusName, arr)
                            }
                        }
                    });
                })
            }
        });
    }

    transferOk(code, selectedTransferPerson, id, statusName, checkedArr) {
        let that = this;
        let body = {};
        let step = checkedArr.length
        body.codes = code;
        body.receiverAccount = selectedTransferPerson.id;
        transferNewMedias(body, res => {
            if (!res) {
                that.setState({progressVisible: false})
                Modal.error({
                    title: '转交失败',
                    content: '转交失败，请联系系统管理员',
                    centered: 'centered',
                    okText: "确定",
                });
            } else {
                that.state.dealCount++;
                let percent = step && Math.ceil((this.state.dealCount / step) * 100);
                that.setState({
                    percent,
                    step
                }, () => {
                    that.transferSuccess(this.state.dealCount, step, percent)
                    //流程结束
                    if (statusName !== "草稿" && statusName !== "已备案") {
                        that.flowEnd(id);
                    }
                })
            }
        })
    }

    flowEnd(id) {
        let params = {
            pojoName: "mediaAudit",
            serviceId: id
        }
        getFlowEndData(params, (res) => {
            console.log(res);
        })
    }

    transferSuccess(dealCount, step, percent) {
        if (dealCount === step && percent === 100) {
            this.setState({
                progressVisible: false
            })
            Modal.success({
                title: '转交成功',
                content:
                    <div>成功向{this.state.selectedTransferPerson && this.state.selectedTransferPerson.name}批量转交{step}个媒体</div>,
                centered: 'centered',
                okText: "确定",
                onOk: () => {
                    this.state.transferPersonBtnShow = true;
                    this.state.selectedTransferPerson = null;
                    this.setState({})
                    this.props.batchTransfer();
                }
            });
        }
    }

    revertData(uuid, callback) {
        let oldData = {};
        getActHistory({bizKey: uuid}, (data) => {
            if (data && data.length > 0) {
                let historyData = data;
                for (var i = 0; i < historyData.length; i++) {
                    if (historyData[i] && historyData[i].taskName === '已备案') {
                        oldData = historyData[i].processData && historyData[i].processData.data;
                        break;
                    }
                }
                if (oldData) {
                    this.revertToOldData(oldData, callback);
                }
            }
        })
    }

    revertToOldData(data, callback) {
        updateNewMedia({...data}, (data) => {
            if (callback) {
                callback();
            }
        }, {
            info: (info) => {
                message.error(info);
            }
        })
    }
}